import './DeleteLead.css';
import { deleteLead } from '../../utilities/api/leads';
import { capitalizeFirstLetter } from '../../utilities/services/capitalizeFirstLetter';

export default function DeleteLead({user, leadItem, getLeads, toggleNotifications}) {
    if (!['admin', 'manager'].includes(user.userType)) {
        return (
            <div className="DeleteLead">
            <h1 className='text-center'>You are not authorized to view this form!</h1>
            </div>
        )
    }

    const deleteLeadItem = async () => {
        try {
            await deleteLead(leadItem._id)
            await toggleNotifications('success', `Lead "${capitalizeFirstLetter(leadItem.leadName)}" Deleted!`, '#E21D12')
            await getLeads()
        } catch (err) {
            await toggleNotifications('error', `Failed to Delete Lead "${capitalizeFirstLetter(leadItem.leadName)}"!`)
            console.log(err)
        }
    }

  return (
    <div className='DeleteLead modal fade' id={`deleteLeadModal${leadItem._id}`}  data-bs-keyboard="true">
        <div className='modal-dialog modal-dialog-centered'>
            <div className='modal-content'>
                <div className='header'>
                    <div className='left'>
                    <div className='first'>
                        <svg width="30" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" opacity='0.8'>
                        <path d="M1.6665 14.1666L9.99984 18.3333L18.3332 14.1666M1.6665 9.99996L9.99984 14.1666L18.3332 9.99996M9.99984 1.66663L1.6665 5.83329L9.99984 9.99996L18.3332 5.83329L9.99984 1.66663Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>                    
                        </svg>
                    </div>
                    <div className='second'>
                        <div className='sec1'>
                        Delete
                        <span className='errorText ps-1'>{capitalizeFirstLetter(leadItem.leadName)}</span>
                        </div>
                    </div>
                    </div>
                    <div className='right'>
                    <svg data-bs-dismiss="modal" width="25" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="16.2666" cy="16.2666" r="15.7666" fill="#EDEFF2" stroke="#EEEEEE"/>
                        <path d="M21.1093 12L12 21.1093M12 12L21.1093 21.1093" stroke="#1B2B41" strokeOpacity="0.8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                    </div>
                </div>
                <div className='modal-body'>
                    <p>Are you sure you want to delete <span className='errorText'>{capitalizeFirstLetter(leadItem.leadName)}</span>?</p>
                </div>
                <div className='d-flex justify-content-center buttonContainer'>
                    <button data-bs-dismiss="modal" className='cancel'>Close</button>
                    <button data-bs-dismiss="modal" className="error delete" type="delete" onClick={deleteLeadItem}>Delete Lead</button>
                </div>
            </div>
        </div>
    </div>
  )
}
